import { Button, Modal } from "react-bootstrap";
import { FareZone } from "../../types/FareZone";
import { DeleteFareZone } from "../../types/DeleteFareZone";
import { useAlertContext } from "../alert/AlertContext";
import FareZoneService from "../../services/FareZoneService";
export interface ConfirmDeleteFormProps {
  fareZone: FareZone;
  onClose: () => void;
  onDeleteFareZone: () => void;
}

const ConfirmDeleteForm = ({
  fareZone,
  onClose,
  onDeleteFareZone,
}: ConfirmDeleteFormProps) => {
  const alertContext = useAlertContext();
  const fareZoneService = new FareZoneService(alertContext.showAlert);
  async function DeleteFareZone(): Promise<void> {
    const deleteFareZone: DeleteFareZone = {
      lastModifiedDate: fareZone.lastModifiedDate,
    };
    await fareZoneService.deleteFareZone(fareZone.id, deleteFareZone);
    onDeleteFareZone();
  }

  return (
    <div
      className="modal show"
      data-bs-spy="scroll"
      style={{
        display: "block",
        position: "initial",
        backgroundColor: "rgba(255,255,255,0.5)",
      }}
    >
      <Modal.Dialog>
        <Modal.Header closeButton onClick={onClose}>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-danger">
            Are you sure you want to delete the Fare Zone {fareZone.name}?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => DeleteFareZone()}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};

export default ConfirmDeleteForm;
